


// mav_filter is semantically encoded:   "croom_" stands for "chatroom_"

//this hard coded list contains two key pieces of info:
//          1) user's member group list
//          2)  group_id => nav_filter (chatroomCodename )  to avoid explicitly listing group_id in URL.
export const ossn_group_membership = {
    coaches_unsorted: 
        [
                    {groupNameOSSN:"Yisen Shi's Room", groupIdOSSN:21, nav_filter: "croom_yisenshi"},  //todo 3.6 10am: change nav_filter to chatroomCodename
                    {groupNameOSSN:"Yuna Guo's Room", groupIdOSSN:115, nav_filter: "croom_yuna_guo"},
                    {groupNameOSSN:"Abigail Guo's Room", groupIdOSSN:116, nav_filter: "croom_abigail_guo"},
                    {groupNameOSSN:"Sofia Pizarro's Room", groupIdOSSN:117, nav_filter: "croom_sofia_pizarro"},
                    {groupNameOSSN:"AaronEthanJaden's Room", groupIdOSSN:148, nav_filter: "croom_aecli"}, 
                    {groupNameOSSN:"Christopher Yang's Room", groupIdOSSN:162, nav_filter: "croom_christopher_yang"},
                    {groupNameOSSN:"Emmi & Evan Vu's Room", groupIdOSSN:164, nav_filter: "croom_emmi_evan_vu"},
                    {groupNameOSSN:"Cloe & Audrey's Room", groupIdOSSN:165, nav_filter: "croom_chloe_audrey_lai"},
                    {groupNameOSSN:"Matt Chen's Room", groupIdOSSN:166, nav_filter: "croom_matt_chen"},
                    {groupNameOSSN:"Noah Van Goor's Room", groupIdOSSN:167, nav_filter: "croom_noah_van_goor"},
                    {groupNameOSSN:"Emily Gao's Room", groupIdOSSN:185, nav_filter: "croom_emily_gao"},
                    {groupNameOSSN:"Kelly & Mark Zheng's Room", groupIdOSSN:186, nav_filter: "croom_kelly_mark"},
                    {groupNameOSSN:"Bruce Duan's Room", groupIdOSSN:187, nav_filter: "croom_bruce_duan"},                   
                    {groupNameOSSN:"Emily & Alan Zhou's Room", groupIdOSSN:205, nav_filter: "croom_emily_alan_zhou"},
                    {groupNameOSSN:"Raphael & Vincent Zhang's Room", groupIdOSSN:221, nav_filter: "croom_raphael_vincent_zhang"},
                    {groupNameOSSN:"Amelia  & Caleb Watts' Room", groupIdOSSN:222, nav_filter: "croom_amelia_caleb_watts"},
                    {groupNameOSSN:"Eric Hu's Room", groupIdOSSN:228, nav_filter: "croom_eric_hu"},
                    {groupNameOSSN:"Tiffany & Anthony Urtis' Room", groupIdOSSN:254, nav_filter: "croom_tiffany_anthony_urtis"},
                    {groupNameOSSN:"Jeremy & Jayden & Jasper Fus' Room", groupIdOSSN:253, nav_filter: "croom_jeremy_jayden_jasper_fu"},
                    {groupNameOSSN:"Chi Zhang's Room", groupIdOSSN:264, nav_filter: "croom_chi_zhang"},
                    {groupNameOSSN:"Winnie Lopez's Room", groupIdOSSN:265, nav_filter: "croom_winnie_lopez"},
                    {groupNameOSSN:"Adrian & Ryder's Room", groupIdOSSN:281, nav_filter: "croom_adrian_ryder"},
       ],   //2025.3.5 hard code OSSN group id here for coaching briefing chatroom

    coaches:
        [
            {groupNameOSSN:"AaronEthanJaden's Room", groupIdOSSN:148, nav_filter: "croom_aecli"},
            {groupNameOSSN:"Abigail Guo's Room", groupIdOSSN:116, nav_filter: "croom_abigail_guo"},
            {groupNameOSSN:"Adrian & Ryder's Room", groupIdOSSN:281, nav_filter: "croom_adrian_ryder"},
            {groupNameOSSN:"Amelia  & Caleb Watts' Room", groupIdOSSN:222, nav_filter: "croom_amelia_caleb_watts"},
            {groupNameOSSN:"Bruce Duan's Room", groupIdOSSN:187, nav_filter: "croom_bruce_duan"},
            {groupNameOSSN:"Chi Zhang's Room", groupIdOSSN:264, nav_filter: "croom_chi_zhang"},
            {groupNameOSSN:"Christopher Yang's Room", groupIdOSSN:162, nav_filter: "croom_christopher_yang"},
            {groupNameOSSN:"Cloe & Audrey's Room", groupIdOSSN:165, nav_filter: "croom_chloe_audrey_lai"},
            {groupNameOSSN:"Emily & Alan Zhou's Room", groupIdOSSN:205, nav_filter: "croom_emily_alan_zhou"},
            {groupNameOSSN:"Emily Gao's Room", groupIdOSSN:185, nav_filter: "croom_emily_gao"},
            {groupNameOSSN:"Emmi & Evan Vu's Room", groupIdOSSN:164, nav_filter: "croom_emmi_evan_vu"},
            {groupNameOSSN:"Eric Hu's Room", groupIdOSSN:228, nav_filter: "croom_eric_hu"},
            {groupNameOSSN:"Kelly & Mark Zheng's Room", groupIdOSSN:186, nav_filter: "croom_kelly_mark"},
            {groupNameOSSN:"Jeremy & Jayden & Jasper Fus' Room", groupIdOSSN:253, nav_filter: "croom_jeremy_jayden_jasper_fu"},
            {groupNameOSSN:"Matt Chen's Room", groupIdOSSN:166, nav_filter: "croom_matt_chen"},
            {groupNameOSSN:"Noah Van Goor's Room", groupIdOSSN:167, nav_filter: "croom_noah_van_goor"},
            {groupNameOSSN:"Raphael & Vincent Zhang's Room", groupIdOSSN:221, nav_filter: "croom_raphael_vincent_zhang"},
            {groupNameOSSN:"Sofia Pizarro's Room", groupIdOSSN:117, nav_filter: "croom_sofia_pizarro"},
            {groupNameOSSN:"Tiffany & Anthony Urtis' Room", groupIdOSSN:254, nav_filter: "croom_tiffany_anthony_urtis"},
            {groupNameOSSN:"Yisen Shi's Room", groupIdOSSN:21, nav_filter: "croom_yisenshi"},
            {groupNameOSSN:"Yuna Guo's Room", groupIdOSSN:115, nav_filter: "croom_yuna_guo"},
            {groupNameOSSN:"Winnie Lopez's Room", groupIdOSSN:265, nav_filter: "croom_winnie_lopez"},
        ],

    guardian_email:
        [
            {groupNameOSSN:"Yisen Shi's Room", groupIdOSSN:21, nav_filter: "croom_yisenshi"}, 
        ],
    "glj-618@hotmail.com":
        [
            {groupNameOSSN:"Yuna Guo's Room", groupIdOSSN:115, nav_filter: "croom_yuna_guo"},
        ],
    "chris92329@gmail.com":
        [
             {groupNameOSSN:"Abigail Guo's Room", groupIdOSSN:116, nav_filter: "croom_abigail_guo"},
        ],
    "fpizarro03@hotmail.com": [
          {groupNameOSSN:"Sofia Pizarro's Room", groupIdOSSN:117, nav_filter: "croom_sofia_pizarro"},  
    ],
    "yisenshiparent@tier1-ibg.com":
    [{groupNameOSSN:"Yisen Shi's Room", groupIdOSSN:21, nav_filter: "croom_yisenshi"}], 

    "Minglee2006@gmail.com":
    [{groupNameOSSN:"AaronEthanJaden's Room", groupIdOSSN:148, nav_filter: "croom_aecli"}], 
    
    "lynnliou@gmail.com":
    [{groupNameOSSN:"Christopher Yang's Room", groupIdOSSN:162, nav_filter: "croom_christopher_yang"}], 

    "ironweasel2002@gmail.com":
    [{groupNameOSSN:"Emmi & Evan Vu's Room", groupIdOSSN:164, nav_filter: "croom_emmi_evan_vu"}],

    "chloe_audrey@gmail.com":
    [{groupNameOSSN:"Cloe & Audrey's Room", groupIdOSSN:165, nav_filter: "croom_chloe_audrey_lai"}],

    "xiangyingkong6@gmail.com":
    [{groupNameOSSN:"Matt Chen's Room", groupIdOSSN:166, nav_filter: "croom_matt_chen"}],

    "stacyvangoor@icloud.com":
    [{groupNameOSSN:"Noah Van Goor's Room", groupIdOSSN:167, nav_filter: "croom_noah_van_goor"}],

    "lxhgwh@gmail.com":
    [{groupNameOSSN:"Emily Gao's Room", groupIdOSSN:185, nav_filter: "croom_emily_gao"}],

    "lizheng916@gmail.com":
    [{groupNameOSSN:"Kelly & Mark's Zheng's Room", groupIdOSSN:186, nav_filter: "croom_kelly_mark"}],

    "maggieduan0909@gmail.com":
    [{groupNameOSSN:"Bruce Duan's Room", groupIdOSSN:187, nav_filter: "croom_bruce_duan"}],

    "huajunandy@gmail.com":
    [{groupNameOSSN:"Emily & Alan Zhou's Room", groupIdOSSN:205, nav_filter: "croom_emily_alan_zhou"}],

    "g.hui20182017@gmail.com":
    [{groupNameOSSN:"Raphael & Vincent Zhang's Room", groupIdOSSN:221, nav_filter: "croom_raphael_vincent_zhang"}],
 
    "tjmwatts@gmail.com":
    [{groupNameOSSN:"Amelia  & Caleb Watts' Room", groupIdOSSN:222, nav_filter: "croom_amelia_caleb_watts"}],

    "patricia.baomei@yahoo.com":
    [{groupNameOSSN:"Eric Hu's Room", groupIdOSSN:228, nav_filter: "croom_eric_hu"}],

    "amado.urtis@icloud.com":
    [{groupNameOSSN:"Tiffany & Anthony Urtis' Room", groupIdOSSN:254, nav_filter: "croom_tiffany_anthony_urtis"}],

    "jeffreyfu1980@gmail.com":
    [{groupNameOSSN:"Jeremy & Jayden & Jasper Fus' Room", groupIdOSSN:253, nav_filter: "croom_jeremy_jayden_jasper_fu"}],


    "sanamfp4@aol.com":
    [{groupNameOSSN:"Winnie Lopez's Room", groupIdOSSN:265, nav_filter: "croom_winnie_lopez"}],

    "zhangchi042804@163.com":
    [{groupNameOSSN:"Chi Zhang's Room", groupIdOSSN:264, nav_filter: "croom_chi_zhang"}],

    "tedvu79@gmail.com":
    [{groupNameOSSN:"Emmi & Evan Vu's Room", groupIdOSSN:164, nav_filter: "croom_emmi_evan_vu"}],

    "kattaeliu@hotmail.com":
    [{groupNameOSSN:"Adrian & Ryder's Room", groupIdOSSN:281, nav_filter: "croom_adrian_ryder"}],
}

// to add:  Chloe & Audrey Lai 165;  Matt Chen 166; Noah Van Goor 167; 

//2025.3.6 needed in OSSNAPI.js::  loadOSSNPostList(), createIBGChatroomOSSNPost(), loadOSSNIBGPlayerList()
export const OSSNGroupMapping_hardCoded = {
    groupCode: 'groupId',
    ibg_attendance: 9,
    playerlisting: 60,
    ibg_attendance_nbtc: 347,
    playerlisting_nbtc: 348,
    ibg_attendance_nbtc_block2: 418,
    playerlisting_nbtc_block2: 419,
    croom_yisenshi: 21,
    croom_yuna_guo: 115,
    croom_abigail_guo: 116,
    croom_sofia_pizarro: 117, 
    croom_aecli: 148,
    croom_christopher_yang: 162,
    croom_emmi_evan_vu:164,
    croom_chloe_audrey_lai: 165,
    croom_matt_chen:166,
    croom_noah_van_goor:167,
    croom_emily_gao: 185,
    croom_kelly_mark: 186,
    croom_bruce_duan:187,
    croom_emily_alan_zhou:205,
    croom_raphael_vincent_zhang:221,
    croom_amelia_caleb_watts:222,
    croom_eric_hu:228,
    croom_tiffany_anthony_urtis:254,
    croom_jeremy_jayden_jasper_fu:253,
    croom_winnie_lopez:265,
    croom_chi_zhang:264,
    croom_adrian_ryder:281,
}
